import React from "react";
import "./header.css";

const Header = () => {
  return (
    <div className="header-wrapper">
      <div className="flex max-width header">

        {/* Only Logo */}
        <div className="header-left flex">
          <img
            src="https://lh3.googleusercontent.com/rd-d/ALs6j_GSmdIipT5A30qsLRhIW0DVBBA7iB-zbVOrPno29TSOIBAsU5PmWrdJjoqc6OZ6GpFFn6oTVGOT0nwSKtEd8-OtpS2j90kUiekbG4h4_bL3zM1p9KWBrzqOd05od6xaMc_quYpzyzU6_vgl_J9tB971BEXyWgIlhwXB6nzWA2vvjuBJTaSCm7WcLH7d31f-kVDQMvVRzJ6MzhWL5TxyFp_OHSZH9Jvt7uwkhO-xbNsd3VQFzYEe1YYITfkwfdtki9sGyEVRwgGWr4yZ_tpIdJPjXF6dUhozOkA76y6gdnJQUeOHCDsVrvKRvvg09ZkkvU90yEuQ5vvOqnZwB99_h92EO9Tw_PgLP2ZpZp8vHawoN4XYesmsgivAiNSxopvf40Av3hdW_2CDsCvG-I3IAy10Ex5egyis5Pt8PANDCbPIhdpiQrUKF56d-e1cPIcbGBK-B1GTs99RLNXUCDI9LzwwRTbnD9GVFx6nQKrJXb6yoWb93tf2qkrueZ7Zhczzdd-8CtIvMnCjoVxZv4z9k3iDERxdubg9G6DcQBhdW0ITnasXaLWutRYiQwzIfWForVa259TFmQmLPd8aRe6VuMQJXHirIl8iccJJQvLnmcOpJqCWGbbJGna3eye043-Wa_u5dmAwEBhI9TKG6-ogg0VqnEhZNNO83teoBt3mo3HRea0fMltojGt6CxBwex6Lb1iWODBG4lDuFtw-gMGoA9nVA-4LyG9vRW3WgEasdPwAOFYf0w0E0IOlqtGYnuhYC6jbfsdtQHAB9t6TvaeBIfeGdVAfkypVOsnIZ3IowUoVWxpumh7agJGg6vySIZ_mA7x5UY8s5IT91t8Y9jvqaLcp0gbAo8RrhHauRk-DZ83mKGJM4Ez_xiHmQJ1s7ecl-9_V1UlTn5PrXIFtiur938aCdpUTq2nOaMZIff34xYicYdEQmwZa0cXLQfPJi9fNjSl6rpiu_GBJvMtz0yEtfWgCezd6A7aAaO76HEf6Jm3MVRFbQeaHpyqiycczGiqzWbegUPwemOZt_Vr7x1Mb=s2940-w2940-h1846?auditContext=prefetch"
            alt="crosswalk-logo"
            className="header-logo"
          />
          <span className="header-brand">Crosswalk</span>
        </div>
      </div>
    </div>
  );
};

export default Header;
